// Central data-testid registry.
export const TID = {
    // Nav
    navLogo: "nav-logo",
    navLink: (id) => `nav-link-${id}`,
    navContactCta: "nav-contact-cta",
    navMobileToggle: "nav-mobile-toggle",
    navMobileClose: "nav-mobile-close",
    navMobileLink: (id) => `nav-mobile-link-${id}`,

    // Hero
    heroGetInTouch: "hero-get-in-touch",
    heroViewWork: "hero-view-work",
    heroHeadline: "hero-headline",

    // Ventures
    ventureCard: (id) => `venture-${id}`,
    ventureVisit: (id) => `venture-visit-${id}`,

    // Projects
    projectCard: (id) => `project-${id}`,
    projectVisit: (id) => `project-visit-${id}`,

    // Services
    serviceCard: (i) => `service-card-${i}`,

    // Stack
    stackTab: (label) => `stack-tab-${label.toLowerCase().replace(/\W+/g, "-")}`,

    // Blog
    blogCategoryChip: (label) => `blog-category-${label.toLowerCase().replace(/\W+/g, "-")}`,
    blogPost: (i) => `blog-post-${i}`,

    // Contact form
    contactName: "contact-name",
    contactEmail: "contact-email",
    contactSubject: "contact-subject",
    contactMessage: "contact-message",
    contactSubmit: "contact-submit",
    contactSuccess: "contact-success",
    contactError: "contact-error",
    contactEmailLink: "contact-email-link",
    contactGithubLink: "contact-github-link",

    // Footer
    footerBackTop: "footer-back-top",
    footerEmailLink: "footer-email-link",
    footerGithubLink: "footer-github-link",

    // Thank you
    thankYouHome: "thank-you-home"
};
